<template>
  <div>
    <div id="editorEmail" ref="reference"></div>
  </div>
</template>
<script>
import i18n from "i18next";
import { uploadMailPic } from "./api.js";
export default {
  props: {
    emailInfo: Object,
    content: String,
    inses: String,
    editorheight: {
      type: String,
      default: "300",
    },
  },
  data() {
    return {
      editorContent: "",
      msg: this.emailInfo,
      contents: this.content,
      iscontents: false,
      isInse: false,
      editors: {},
      E: window.wangEditor,
    };
  },
  methods: {
    getContent: function () {
      alert(this.editorContent);
    },
    //清除副文本编辑器值
    clearvalue() {
      this.editors.txt.clear();
    },
    signContent(val, state) {
      if (state) {
        var div = `<div style="color:red">${val}</div>`;
      } else {
        var div = `<p>${val}</p>`;
      }
      this.editors.txt.append(div);
    },
  },
  watch: {
    content(val) {
      this.$emit("editorContent", val);
      if (this.inses.length !== 0) {
        this.editors.txt.append(val);
      } else {
        this.editors.txt.html(val);
      }
      true;
    },
    inses(val) {
      if (this.editorContent !== "") {
        this.editors.txt.append(val);
      } else {
        this.editors.txt.html(val);
      }
    },
    editorContent(val) {
      this.$emit("editorContent", val);
    },
  },
  mounted() {
    var editor = new this.E(this.$refs.reference);
    this.editors = editor;
    editor.config.onchange = () => {
      this.editorContent = editor.txt.html();
    };
    editor.config.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "strikeThrough", // 删除线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      "link", // 插入链接
      "list", // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "emoticon", // 表情
      "image", // 插入图片
      "table", // 表格
      "video", // 插入视频
      "code", // 插入代码
      "undo", // 撤销
      "redo", // 重复
    ];
    editor.config.customUploadImg = (resultFiles, insertImgFn) => {
      // resultFiles 是 input 中选中的文件列表
      // insertImgFn 是获取图片 url 后，插入到编辑器的方法
      let formData = new FormData();
      formData.append("file", resultFiles[0]);
      uploadMailPic(formData).then((res) => {
        if (res.data) {
          // 上传图片，返回结果，将图片插入到编辑器中
          insertImgFn(res.data.url);
        }
      });
    };
    // 取消自动 focus
    editor.config.focus = false;
    editor.config.zIndex = 100; //修改菜单优先级
    //过滤掉复制文本中自带的样式,默认开启
    editor.config.pasteFilterStyle = false;
    editor.config.height = this.editorheight;
    // 自定义处理粘贴的文本内容
    editor.config.linkImgCallback = function (url) {};
    editor.config.linkCheck = function (text, link) {
      return true; // 返回 true 表示校验成功
      // return '验证失败' // 返回字符串，即校验失败的提示信息
    };
    // 自定义配置颜色（字体颜色、背景色）
    editor.config.colors = [
      "#000000",
      "#eeece0",
      "#1c487f",
      "#4d80bf",
      "#c24f4a",
      "#8baa4a",
      "#7b5ba1",
      "#46acc8",
      "#f9963b",
      "#ffffff",
    ];
    // 表情面板可以有多个 tab ，因此要配置成一个数组。数组每个元素代表一个 tab 的配置
    editor.config.emotions = [
      {
        // tab 的标题
        title: "默认",
        // type -> 'emoji' / 'image'
        type: "image",
        // content -> 数组
        content: [
          {
            alt: "[坏笑]",
            src: "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/50/pcmoren_huaixiao_org.png",
          },
          {
            alt: "[舔屏]",
            src: "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/40/pcmoren_tian_org.png",
          },
        ],
      },
      {
        // tab 的标题
        title: "emoji",
        // type -> 'emoji' / 'image'
        type: "emoji",
        // content -> 数组
        content: ["😀", "😃", "😄", "😁", "😆"],
      },
    ];
    // 自定义字体
    editor.config.fontNames = [
      "宋体",
      "微软雅黑",
      "Arial",
      "Tahoma",
      "Verdana",
    ];
    //多语言
    if (this.$store.state.userInfoObj.language != "zh") {
      editor.config.lang = "en";
      editor.i18next = i18n;
      //英文环境下字体
      editor.config.fontNames = [
        "SimSun",
        "Microsoft YaHei",
        "Arial",
        "Tahoma",
        "Verdana",
      ];
    }
    // 隐藏“网络图片”tab
    editor.config.showLinkImg = false;
    // 取消自动 focus
    editor.config.focus = false;
    // 下面两个配置，使用其中一个即可显示“上传图片”的tab。但是两者不要同时使用！！！
    // editor.config.uploadImgShowBase64 = true; // 使用 base64 保存图片不建议使用这种，我只是图个方便
    // editor.customConfig.uploadImgServer = '/upload'  // 上传图片到服务器
    editor.create();
  },
};
</script>

<style lang="scss" scoped>
/* table 样式 */
table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

table td,
table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}

table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}

/* blockquote 样式 */
blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

/* code 样式 */
code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}

pre code {
  display: block;
}

/* ul ol 样式 */
ul,
ol {
  margin: 10px 0 10px 20px;
}

/*
  ::v-deep .w-e-toolbar {
    flex-wrap: wrap !important;
  } */

::v-deep #editorEmail {
  .w-e-text {
    // overflow-y: scroll;
  }
  .w-e-text-container {
    z-index: 1 !important;
    // overflow: hidden;
  }

  .w-e-toolbar {
    flex-wrap: wrap;
    // z-index: 1 !important;
  }

  .w-e-menu {
    z-index: auto !important;
    .w-e-droplist {
      z-index: 2 !important;
    }
  }
}
</style>